import React, { PropTypes } from 'react';
import { Articles, Details } from '../../containers';
import { Loader } from '../../components';

const App = ({ news, announcements, route }) => {
  if (route === 'press') {
    return <Details news={news} announcements={announcements} route={route} />;
  }

  if (route === 'news') {
    return <Articles title="In the News" items={news} route={route} />;
  }

  if (route === 'announcements') {
    return <Articles title="Announcements" items={announcements} route={route} />;
  }

  return <Loader />;
};

const itemValidation = {
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  author: PropTypes.string,
  avatar: PropTypes.string,
  fullDate: PropTypes.string.isRequired
};

App.propTypes = {
  announcements: PropTypes.arrayOf(PropTypes.shape(itemValidation)),
  news: PropTypes.arrayOf(PropTypes.shape(itemValidation)),
  route: PropTypes.string
};

export default App;



// WEBPACK FOOTER //
// ./src/pages/press/containers/App/App.js